import { createFeatureSelector, createSelector } from '@ngrx/store';
import { LoadingState } from './reducer';

export const selectLoadingState = createFeatureSelector<LoadingState>('loading');

export const selectIsLoading = (key: string) => createSelector(
  selectLoadingState,
  (state: LoadingState) => state[key] || false
);
